// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1f--W","name":"styles_name__1e79f","phone":"styles_phone__2l2IT"};